<template>
  <content-viewer :title="$t('all_map')" modal-class="w-640px">
    <template #trigger="{ open }">
      <nd-button type="text" class="active -mr-2" size="mini" :class="textClass" @click="open">{{ $t('all_map') }}</nd-button>
    </template>
    <template #default>
      <iframe-map :target="props.target" :latitude="props.latitude" :longitude="props.longitude" />
    </template>
  </content-viewer>
</template>

<script setup lang="ts">
import ContentViewer from '@/components/common/content-viewer.vue'
import IframeMap from '@/components/common/iframe-map.vue'

const props = defineProps<{
  target: string
  latitude?: number
  longitude?: number
  textClass?: string
}>()
</script>

<style lang="scss" scoped></style>
